import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { CardCell, CellsWrapper, Card } from 'modules/journey/card/styled';
import { Flexer, Checkbox } from '@ontruck/orc';

import {
  IdCell,
  DriverCell,
  DriverInfoCell,
  HeightCell,
  NotReviewedCell,
  MissingPodCell,
  NumberOfItemsCell,
  WeightCell,
  DistanceCell,
  HandledByCell,
  LifgateCell,
  SideloadCell,
  IncidentsCell,
  ShipperOrdersCell,
  TopLoadCell,
  AdditionalDocumentsCell,
  BusinessCell,
} from 'modules/journey/card/cells';

import { AssignedStopsRow, StopsRow } from 'modules/journey/card/rows';
import { IS_TENANT } from 'tenant/config';
import { HOST, TENANTS_NAMES } from 'tenant/host_config';

const AssignedJourneyCard = ({
  journeyId,
  isSelected,
  onChangeCheckbox,
  isFullyCancelled,
  onCardClick,
  showCheckbox,
  booking_number,
  logistics_operator_code,
  reference_number,
  seal_number,
}) => {
  console.log('AssignedJourneyCard intraser fields', {
    booking_number,
    logistics_operator_code,
    reference_number,
    seal_number,
  });

  const IS_INTRASER = HOST === TENANTS_NAMES.intraser;
  const cardContent = (
    <Card
      onClick={onCardClick}
      clickable
      lightCard={isFullyCancelled}
      data-e2e={`journey_card__${journeyId}`}
    >
      <CellsWrapper wrapperHeight={40} pLeft="XS" pRight="XS">
        <CardCell
          mRight="S"
          cellMaxWidth={'290,252,239'}
          cellMinWidth={'330,272,229'}
          cellColor="grey700"
        >
          <CellsWrapper justifyContent="flex-start">
            <CardCell mRight="XS" cellMinWidth={60} flex="0 1 auto">
              <DriverCell journeyId={journeyId} />
            </CardCell>
            <CardCell flex="0 1 auto">
              <DriverInfoCell journeyId={journeyId} />
            </CardCell>
          </CellsWrapper>
        </CardCell>
        <CardCell cellWidth={88} mRight="XS" cellParent>
          <LifgateCell journeyId={journeyId} mRight="XS" />
          <SideloadCell journeyId={journeyId} />
          <TopLoadCell journeyId={journeyId} />
          <AdditionalDocumentsCell journeyId={journeyId} />
        </CardCell>
        <CardCell cellWidth={10} mRight="XS" cellParent>
          {!IS_TENANT && <BusinessCell journeyId={journeyId} />}
        </CardCell>
        <CardCell cellWidth={65} mRight="S,XS" alignRight cellColor="grey700">
          <NumberOfItemsCell journeyId={journeyId} showMax showEquivalents />
        </CardCell>
        {IS_INTRASER ? (
          <CardCell cellWidth={62 + 57 + 52} mRight="S,XS" alignRight cellColor="grey700">
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '2px',
                color: '#54708C',
                paddingLeft: '20px',
              }}
            >
              <div style={{ textAlign: 'left' }}>{logistics_operator_code || '—'}</div>
              <div style={{ textAlign: 'left' }}>{seal_number || '—'}</div>
            </div>
          </CardCell>
        ) : (
          <>
            <CardCell cellWidth={62} mRight="S,XS" alignRight cellColor="grey700">
              <WeightCell journeyId={journeyId} showMax />
            </CardCell>
            <CardCell cellWidth={'57'} mRight="S,XS" alignRight cellColor="grey700">
              <HeightCell journeyId={journeyId} />
            </CardCell>
            <CardCell cellWidth={52} mRight="S,XS" alignRight>
              <DistanceCell journeyId={journeyId} openInGoogleMaps />
            </CardCell>
          </>
        )}
        <CardCell cellGrow cellMaxWidth={'20,30,0'} />
        <CardCell cellWidth={106} mRight="S,XS,XS">
          <NotReviewedCell journeyId={journeyId} />
          <MissingPodCell journeyId={journeyId} />
        </CardCell>
        <CardCell cellWidth={'56,56,43'} alignRight cellColor="grey700" mRight="N,N,XS">
          <IncidentsCell journeyId={journeyId} />
        </CardCell>
        <CardCell cellWidth={'72,72,55'} alignRight mRight="S,XS" cellColor="grey700">
          <IdCell id={journeyId} />
        </CardCell>
        <CardCell cellGrow cellWidth={'115,115,79'} alignRight cellOverflow>
          {IS_INTRASER ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '2px',
                color: '#54708C',
                paddingLeft: '20px',
              }}
            >
              <div style={{ textAlign: 'left' }}>{booking_number || '—'}</div>
              <div style={{ textAlign: 'left' }}>{reference_number || '—'}</div>
            </div>
          ) : (
            <HandledByCell journeyId={journeyId} />
          )}
        </CardCell>
      </CellsWrapper>
      <CellsWrapper wrapperHeight={32} pLeft="XS" pRight="XS" justifyContent="flex-start">
        <ShipperOrdersCell journeyId={journeyId} />
      </CellsWrapper>
      <CellsWrapper wrapperColumn transparent>
        <StopsRow journeyId={journeyId} row={AssignedStopsRow} />
      </CellsWrapper>
    </Card>
  );

  if (!showCheckbox) {
    return <>{cardContent}</>;
  }

  return (
    <Flexer.Parent>
      <Flexer.Child flex="0">
        <Checkbox label={''} checked={isSelected} onChange={onChangeCheckbox} />
      </Flexer.Child>
      <Flexer.Child flex="1">{cardContent}</Flexer.Child>
    </Flexer.Parent>
  );
};

AssignedJourneyCard.propTypes = {
  journeyId: PropTypes.number.isRequired,
  onCardClick: PropTypes.func,
  isFullyCancelled: PropTypes.bool,
  cardRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  booking_number: PropTypes.string,
  logistics_operator_code: PropTypes.string,
  reference_number: PropTypes.string,
  seal_number: PropTypes.string,
};

export default memo(AssignedJourneyCard);
